<!--
 * @Author: your name
 * @Date: 2020-11-19 16:42:47
 * @LastEditTime: 2021-04-06 14:55:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /v-intersection/src/components/code/demo1.vue
-->
<template>
  <div class="demo">

    <div class="content">
      <div class="block blue" v-intersection="handler"></div>
      <div class="block"></div>
    </div>

    <span class="tip button1" :class="isShow ? 'green' : 'red'">isShow?:{{ isShow }} times:{{ times }}</span>
  
  

  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: "???",
      times: 0,
    };
  },
  computed: {},
  methods: {

    handler(entries) {
      let flag =  entries[0].isIntersecting 
     flag ? (this.isShow = true) : (this.isShow = false);
      this.times++;
    },

    //
 
  },
};
</script>

<style lang="css">
.demo {
  position: relative;
  border-radius: 20px;

  border: 1px solid #cccccc;
  overflow: hidden;
}
.content {
  width: 100%;
  height: 30vh;
  overflow-y: scroll;
}

.block {
  width: 10vh;
  height: 10vh;
  margin: 40vh auto;
  margin-bottom: 20%;

  border-radius: 20px;
}
</style>
